import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import './Call.css'
import { useNavigate } from 'react-router-dom'
import {
  setShowCallModal,
  setCallDetails,
  setCallData
} from '../../features/data/dataSlice'
import peer from '../../services/peer'
import {
  Volume2,
  Mic,
  PhoneOff,
  Minimize2,
  UserPlus,
  Ellipsis,
  Video,
  PhoneCall,
  MessagesSquare,
  MessageSquareText,
  X,
  MicOff
} from 'lucide-react'
import AudioVisualizer from './AudioVisualizer'

// Format call duration as MM:SS
export const formatDuration = seconds => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins.toString().padStart(2, '0')}:${secs
    .toString()
    .padStart(2, '0')}`
}

function TimerComp({ callDuration }) {
  return (
    <span style={{ fontSize: '14px' }}>{formatDuration(callDuration)}</span>
  )
}

function Call({
  socket,
  showCallModal,
  setShowCallModal,
  selectedChat,
  userInfo,
  setCallData,
  callData,
  callDetails,
  setCallDetails
}) {
  const [remoteSocketId, setRemoteSocketId] = useState(null)
  const [myStream, setMyStream] = useState(null)
  const [remoteStream, setRemoteStream] = useState(null)
  const [setCallType, setsetCallType] = useState(null)
  // ringing, Not Answered, connected, connection
  const [CallCurrentStatus, setCallCurrentStatus] = useState(null)
  const [isVideoMuted, setIsVideoMuted] = useState(false)
  const [RefUuid, setRefUuid] = useState(null)
  const [isCallInitiated, setIsCallInitiated] = useState(false)
  const [callDuration, setCallDuration] = useState(0)
  const [checkCallAccepted, setCheckCallAccepted] = useState(false)
  const [isMicMuted, setIsMicMuted] = useState(false)
  //   console.log(callDuration)
  const navigate = useNavigate()

  const [remoteUserInfo, setRemoteUserInfo] = useState(null)

  // Declare intervalId outside the component or useEffect
  const timeoutIdRef = useRef(null)
  const clearSetTimeout = useRef(null)
  const timerIdRef = useRef(null)

  const myVideoRef = useRef(null)
  const remoteVideoRef = useRef(null)

  // Add function to toggle microphone mute
  const toggleMicMute = useCallback(() => {
    if (myStream) {
      const audioTrack = myStream.getAudioTracks()[0]
      if (audioTrack) {
        audioTrack.enabled = !audioTrack.enabled
        setIsMicMuted(!audioTrack.enabled)
      }
    }
  }, [myStream])

  const HandleRinging = useCallback(
    (RefUuid, elapsedSeconds) => {
      if (elapsedSeconds > 31) {
        console.log('Ringing timeout reached')
        setCheckCallAccepted(true)
        return
      }

      timeoutIdRef.current = setTimeout(async () => {
        if (!socket || !selectedChat || !userInfo) return

        console.log(elapsedSeconds)
        if (elapsedSeconds <= 31) {
          const offer = await peer.getOffer()
          const usercall = {
            type: 'new message2',
            message: {
              createdAt: new Date().toISOString(),
              content: '',
              oldUuid: RefUuid,
              callData: {
                status: 'ringing',
                subtype: 'user:call',
                to: ID,
                offer,
                room: selectedChat._id,
                from: userInfo._id,
                callDuration: elapsedSeconds,
                initiator: {
                  _id: userInfo._id,
                  name: userInfo.name,
                  pic: userInfo.pic || null,
                  phone: userInfo.phone || null
                }
              },
              type: 'call',
              chatId: {
                isGroupChat: false,
                users: selectedChat.users,
                _id: selectedChat._id,
                chatName: selectedChat.isGroupChat
                  ? selectedChat.chatName
                  : null,
                createdAt: selectedChat.createdAt || new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                __v: 0,
                sender: {
                  _id: userInfo._id,
                  name: userInfo.name
                }
              }
            }
          }

          console.log('Ringing')
          setCallCurrentStatus('Ringing')
          socket.send(JSON.stringify(usercall))

          // Recursively call HandleRinging again after 3 seconds
          HandleRinging(RefUuid, elapsedSeconds + 3)
        } else {
          console.log('clear')
          setCheckCallAccepted(true)
          clearInterval(timeoutIdRef.current)
          timeoutIdRef.current = null // Reset intervalId
        }
      }, 3000)
    },
    [
      socket,
      selectedChat,
      userInfo,
      myStream,
      timeoutIdRef.current,
      CallCurrentStatus
    ]
  )

  useEffect(() => {
    if (checkCallAccepted && myStream) {
      // console.log('Not Answered');
      setCallCurrentStatus('Not Answered')
      if (myStream) {
        myStream.getTracks().forEach(track => track.stop())
      }
      setMyStream(null)
      setCheckCallAccepted(false)
    }
  }, [checkCallAccepted, myStream])

  useEffect(() => {
    // let waitToRinging = null
    let autoCloseTimeout = null
    if (socket) {
      socket.onmessage = event => {
        const data = JSON.parse(event.data)
        // console.log(data)
        setsetCallType(data)
        switch (data?.message?.callData?.subtype) {
          case 'call:initiated':
            const tempcalldata0 = data.message.uuid
            setRefUuid(tempcalldata0)
            setIsCallInitiated(true)
            // waitToRinging = setTimeout(() => {
            //   HandleRinging(tempcalldata0, 0)
            // }, 3000)
            HandleRinging(tempcalldata0, 0)
            break
          case 'incomming:call':
            const tempcalldata9 = data.message.uuid
            if (data.message.callType) setCallDetails(data.message.callType)
            setRefUuid(tempcalldata9)
            setCallCurrentStatus('Incomming')

            const initiator = data.message.callData?.initiator
            if (initiator) {
              setRemoteUserInfo(initiator)
            }

            if (data?.message?.callData?.callDuration >= 28) {
              handleAutoCut()
            }
            break
          case 'call:accepted':
            const tempcalldata = JSON.parse(
              JSON.stringify(data.message.callData)
            )
            tempcalldata.to = tempcalldata.from
            tempcalldata.from = userInfo._id
            handleCallAccepted(tempcalldata)
            // console.log('one');
            timeoutIdRef.current = null
            clearInterval(timeoutIdRef.current)
            clearSetTimeout.current = null
            clearTimeout(clearSetTimeout.current)
            // waitToRinging = null
            // clearTimeout(waitToRinging)
            // console.log('Connecting');
            setCallCurrentStatus('Connecting')
            break
          case 'peer:nego:needed':
            const tempcalldata2 = JSON.parse(
              JSON.stringify(data.message.callData)
            )
            tempcalldata2.to = tempcalldata2.from
            tempcalldata2.from = userInfo._id
            handleNegoNeedIncomming(tempcalldata2)
            // setCallCurrentStatus('Connecting')
            break
          case 'peer:nego:final':
            const tempcalldata3 = JSON.parse(
              JSON.stringify(data.message.callData)
            )
            tempcalldata3.to = tempcalldata3.from
            tempcalldata3.from = userInfo._id
            handleNegoNeedFinal(tempcalldata3)
            // console.log('Connected');
            setCallCurrentStatus('Connected')
            break
          case 'call:ended':
            handleEndCall('userEnded')
            break
          default:
          // console.log('Unknown message type:', data.type)
        }
      }
    }
    // Cleanup interval on component unmount
    return () => {
      // if (timeoutIdRef.current) {
      // console.log('return')
      // clearInterval(timeoutIdRef.current)
      // timeoutIdRef.current = null
      // waitToRinging = null
      // clearTimeout(waitToRinging)
      clearTimeout(autoCloseTimeout)
      // }
    }
  }, [socket, myStream, CallCurrentStatus])

  const ID = selectedChat?.users?.filter(user => user._id !== userInfo?._id)[0]
    ._id

  // console.log(selectedChat);
  const handleCallUser = useCallback(
    async type => {
      const stream = await navigator?.mediaDevices?.getUserMedia({
        audio: true,
        video: callDetails === 'Video'
      })
      setMyStream(stream)

      // Set the callee info (the other person)
      const remoteUser = selectedChat.users.find(u => u._id !== userInfo._id)
      setRemoteUserInfo(remoteUser)

      const offer = await peer.getOffer()
      const usercall = {
        type: 'new message2',
        message: {
          createdAt: new Date().toISOString(),
          content: '',
          callData: {
            status: 'initiated',
            subtype: 'user:call',
            to: remoteUser._id,
            offer,
            room: selectedChat._id,
            from: userInfo._id,
            callDuration: 0,
            initiator: {
              _id: userInfo._id,
              name: userInfo.name,
              pic: userInfo.pic || null,
              phone: userInfo.phone || null
            }
          },
          callType: type,
          type: 'call',
          chatId: {
            isGroupChat: false,
            users: selectedChat.users,
            _id: selectedChat._id,
            chatName: selectedChat.isGroupChat ? selectedChat.chatName : null,
            createdAt: selectedChat.createdAt || new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            __v: 0,
            sender: {
              _id: userInfo._id,
              name: userInfo.name
            }
          }
        }
      }

      socket.send(JSON.stringify(usercall))
    },
    [selectedChat, socket, userInfo, callDetails]
  )

  useEffect(() => {
    if (showCallModal == 'calling' && callDetails) {
      // console.log('Connecting');
      setCallCurrentStatus('Connecting')
      handleCallUser(callDetails)
    }
  }, [showCallModal, callDetails])

  const handleIncommingCall = useCallback(
    async ({}) => {
      //   console.log(callData)
      if (callData && callData.subtype == 'incomming:call') {
        const offer = callData.offer
        const from = callData.from
        // console.log(`[ handleIncommingCall ] Incoming Call`, from, offer)
        const ans = await peer.getAnswer(offer)
        const IncommingCall = {
          type: 'new message2',
          message: {
            createdAt: new Date().toISOString(),
            content: '',
            oldUuid: RefUuid,
            callData: {
              status: 'accepted',
              subtype: 'call:accepted',
              to: from,
              ans,
              room: selectedChat._id,
              from: userInfo._id,
              initiator: {
                _id: userInfo._id,
                name: userInfo.name,
                pic: userInfo.pic || null,
                phone: userInfo.phone || null
              }
            },
            type: 'call',
            chatId: {
              isGroupChat: false,
              users: selectedChat.users, // Full user objects (will be mapped in optimizeMessagePayload)
              _id: selectedChat._id,
              chatName: selectedChat.isGroupChat ? selectedChat.chatName : null,
              createdAt: selectedChat.createdAt || new Date().toISOString(),
              updatedAt: new Date().toISOString(),
              __v: 0,
              sender: {
                _id: userInfo._id,
                name: userInfo.name
              }
            }
          }
        }
        socket.send(JSON.stringify(IncommingCall))
        // console.log('Connected');
        setCallCurrentStatus('Connected')
      }
    },
    [socket, selectedChat, callData, setCallCurrentStatus]
  )

  const sendStreams = useCallback(() => {
    // console.log('after useeffect se chal raha hai !!!!')
    // console.log('[ sendStreams ] ', myStream)
    for (const track of myStream?.getTracks()) {
      peer.peer.addTrack(track, myStream)
    }
  }, [myStream])

  const handleCallAccepted = useCallback(
    tempcalldata => {
      if (tempcalldata.subtype == 'call:accepted') {
        peer.setLocalDescription(tempcalldata.ans)
        // console.log(' [ handleCallAccepted ] Call Accepted!', { tempcalldata })
        sendStreams()
      }
      // Clear the interval if it exists
      if (timeoutIdRef.current && tempcalldata.subtype == 'call:accepted') {
        clearInterval(timeoutIdRef.current)
        timeoutIdRef.current = null
      }
    },
    [sendStreams]
  )

  const handleNegoNeeded = useCallback(async () => {
    // console.log(' [ handleNegoNeeded ] ')
    const offer = await peer.getOffer()
    const PeerNegoNeed = {
      type: 'new message2',
      message: {
        createdAt: new Date().toISOString(),
        content: '',
        oldUuid: RefUuid,
        callData: {
          status: 'peer:nego:needed',
          subtype: 'peer:nego:needed',
          to: ID,
          offer,
          room: selectedChat._id,
          from: userInfo._id,
          initiator: {
            _id: userInfo._id,
            name: userInfo.name,
            pic: userInfo.pic || null,
            phone: userInfo.phone || null
          }
        },
        type: 'call',
        chatId: {
          isGroupChat: false,
          users: selectedChat.users, // Full user objects (will be mapped in optimizeMessagePayload)
          _id: selectedChat._id,
          chatName: selectedChat.isGroupChat ? selectedChat.chatName : null,
          createdAt: selectedChat.createdAt || new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          __v: 0,
          sender: {
            _id: userInfo._id,
            name: userInfo.name
          }
        }
      }
    }
    socket.send(JSON.stringify(PeerNegoNeed))
    // console.log('Connecting');
    setCallCurrentStatus('Connecting')
  }, [
    remoteSocketId,
    socket,
    selectedChat,
    userInfo,
    setCallCurrentStatus,
    RefUuid
  ])

  useEffect(() => {
    // console.log('addeventpeer')
    peer.peer.addEventListener('negotiationneeded', handleNegoNeeded)
    return () => {
      //   console.log('removeeventpeer')
      peer.peer.removeEventListener('negotiationneeded', handleNegoNeeded)
    }
  }, [handleNegoNeeded])

  const handleNegoNeedIncomming = useCallback(
    async tempcalldata2 => {
      const ans = await peer.getAnswer(tempcalldata2.offer)
      //   console.log('[ handleNegoNeedIncomming ]')
      const PeerNegoDone = {
        type: 'new message2',
        message: {
          createdAt: new Date().toISOString(),
          content: '',
          oldUuid: RefUuid,
          callData: {
            status: 'peer:nego:done',
            subtype: 'peer:nego:done',
            to: ID,
            ans,
            room: selectedChat._id,
            from: userInfo._id,
            initiator: {
              _id: userInfo._id,
              name: userInfo.name,
              pic: userInfo.pic || null,
              phone: userInfo.phone || null
            }
          },
          type: 'call',
          chatId: {
            isGroupChat: false,
            users: selectedChat.users, // Full user objects (will be mapped in optimizeMessagePayload)
            _id: selectedChat._id,
            chatName: selectedChat.isGroupChat ? selectedChat.chatName : null,
            createdAt: selectedChat.createdAt || new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            __v: 0,
            sender: {
              _id: userInfo._id,
              name: userInfo.name
            }
          }
        }
      }
      socket.send(JSON.stringify(PeerNegoDone))
      if (showCallModal === 'recieving') {
        sendStreams()
      }
    },
    [socket, selectedChat, userInfo, sendStreams, showCallModal, RefUuid]
  )

  const handleNegoNeedFinal = useCallback(
    async tempcalldata3 => {
      //   console.log('[ handleNegoNeedFinal ]')
      await peer.setLocalDescription(tempcalldata3.ans)
      // console.log('Connected');
      setCallCurrentStatus('Connected')
    },
    [setCallCurrentStatus]
  )

  const handleAutoCut = useCallback(() => {
    // console.log('[ handleAutoCut ] Call ended by remote user')
    if (myStream) {
      myStream.getTracks().forEach(track => track.stop())
    }
    // console.log(null);
    setCallCurrentStatus(null)
    setIsCallInitiated(false)
    setRefUuid(null)
    setRemoteSocketId(null) // Clear the remote socket ID
    setMyStream(null) // Clear the local stream
    setCallData(null) // Clear the call data
    setShowCallModal(false)
    setCallDetails(null)
    setCallDuration(0)
    // setTimer(null)
  }, [myStream])

  const handleEndCall = useCallback(
    text => {
      //   console.log('[ handleEndCall ] Ending call')
      if (myStream) {
        myStream.getTracks().forEach(track => track.stop())
      }
      setMyStream(null)
      setRemoteStream(null)

      // Clear the ringing timeout
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current)
        timeoutIdRef.current = null
      }

      // peer.peer.close()
      if (text === 'userEnded') {
        // console.log('CallCurrentStatus', CallCurrentStatus);
        if (CallCurrentStatus === 'Connected') {
          // console.log('Call End')
          setCallCurrentStatus('Call End')
        } else {
          // console.log('Not Answered');
          setCallCurrentStatus('Not Answered')
        }
        setIsCallInitiated(false)
        setRefUuid(null)
        setRemoteSocketId(null) // Clear the remote socket ID
        setMyStream(null) // Clear the local stream
        setCallData(null) // Clear the call data

        // setShowCallModal(false)
        // setCallDuration(0)
        // setTimer(null)
      } else {
        const CallEnd = {
          type: 'new message2',
          message: {
            createdAt: new Date().toISOString(),
            content: '',
            oldUuid: RefUuid,
            callData: {
              status: 'ended',
              subtype: 'call:end',
              to: ID,
              room: selectedChat._id,
              from: userInfo._id,
              callDuration: callDuration,
              initiator: {
                _id: userInfo._id,
                name: userInfo.name,
                pic: userInfo.pic || null,
                phone: userInfo.phone || null
              }
            },
            type: 'call',
            chatId: {
              isGroupChat: false,
              users: selectedChat.users, // Full user objects (will be mapped in optimizeMessagePayload)
              _id: selectedChat._id,
              chatName: selectedChat.isGroupChat ? selectedChat.chatName : null,
              createdAt: selectedChat.createdAt || new Date().toISOString(),
              updatedAt: new Date().toISOString(),
              __v: 0,
              sender: {
                _id: userInfo._id,
                name: userInfo.name
              }
            }
          }
        }
        socket.send(JSON.stringify(CallEnd))
        // console.log(null);
        setCallCurrentStatus(null)
        setIsCallInitiated(false)
        setRefUuid(null)
        setRemoteSocketId(null) // Clear the remote socket ID
        setMyStream(null) // Clear the local stream
        setCallData(null) // Clear the call data
        setShowCallModal(false)
        setCallDetails(null)
        setCallDuration(0)
        setRemoteUserInfo(null)

        // setTimer(null)
      }
    },
    [
      myStream,
      socket,
      remoteSocketId,
      navigate,
      selectedChat,
      userInfo,
      timeoutIdRef,
      CallCurrentStatus,
      callDuration
    ]
  )

  useEffect(() => {
    peer.peer.addEventListener('track', async ev => {
      const remoteStream = ev.streams
      //   console.log('[ GOT TRACKS!! ]', remoteStream[0])
      setRemoteStream(remoteStream[0])
    })
  }, [])

  function CancelCalling() {
    setShowCallModal(false)
    setCallDetails(null)
    if (myStream) {
      handleEndCall()
    }
  }

  useEffect(async () => {
    if (callData && callData.subtype === 'incomming:call') {
      //   console.log(callData)
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: callDetails === 'Video'
      })
      // console.log(stream)
      setMyStream(stream)
      setRemoteSocketId(callData.from)
      // console.log('Incomming');
      setCallCurrentStatus('Incomming')
    }
  }, [callData, callDetails])

  // Update call duration when connected
  useEffect(() => {
    // console.log(CallCurrentStatus);
    if (CallCurrentStatus === 'Connected') {
      timerIdRef.current = setInterval(() => {
        setCallDuration(prev => prev + 1)
      }, 1000)
      // setTimer(timerIdRef.current)
    }
    return () => {
      clearInterval(timerIdRef.current)
      timerIdRef.current = null // Reset timerId
    }
  }, [CallCurrentStatus])

  useEffect(() => {
    if (myStream && myVideoRef.current) {
      myVideoRef.current.srcObject = myStream
    }
  }, [myStream])

  useEffect(() => {
    if (remoteStream && remoteVideoRef.current) {
      remoteVideoRef.current.srcObject = remoteStream
      if (callDetails === 'Video') remoteVideoRef.current.muted = true // Initially muted

      // Unmute after 3 seconds
      const unmuteTimeout = setTimeout(() => {
        if (remoteVideoRef.current && callDetails === 'Video') {
          remoteVideoRef.current.muted = false
        }
      }, 3000)

      // Cleanup timeout on component unmount or when remoteStream changes
      return () => clearTimeout(unmuteTimeout)
    }
  }, [remoteStream])

  // Auto-close call end screen after 4 seconds
  useEffect(() => {
    let autoCloseTimeout = null
    if (
      (CallCurrentStatus === 'Call End' ||
        CallCurrentStatus === 'Not Answered') &&
      showCallModal
    ) {
      autoCloseTimeout = setTimeout(() => {
        setShowCallModal(false)
        setCallDetails(null)
        setCallDuration(0)
      }, 1800)
    }
    return () => clearTimeout(autoCloseTimeout)
  }, [CallCurrentStatus, showCallModal])

  return (
    <>
      <Modal fullscreen show={showCallModal} onHide={CancelCalling}>
        <Modal.Body className="callBody">
          {(showCallModal === 'calling' || showCallModal === 'recieving') && (
            <div
              className={`h-100 d-flex flex-column RoomVideoContainer ${
                !remoteStream ? 'Ringing' : 'Connected'
              }`}
            >
              <div className="w-100 d-flex justify-content-between">
                <span className=" d-flex flex-column align-items-center justify-content-center m-auto">
                  <h2 className="m-0">{remoteUserInfo?.name || ''}</h2>
                  {/* <p
                    style={{
                      fontSize: '14px',
                      marginTop: '-2px',
                      textAlign: 'center'
                    }}
                  >
                    {remoteUserInfo?.phone || 'No phone'}
                  </p> */}
                  {CallCurrentStatus === 'Connected' ? (
                    <TimerComp callDuration={callDuration} />
                  ) : (
                    <label className="call-status">{CallCurrentStatus}</label>
                  )}
                </span>
              </div>
              {myStream && callDetails === 'Video' && (
                <div className="MyScreen">
                  <video
                    autoPlay
                    muted
                    playsInline
                    webkit-playsinline="true"
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      transform: 'scaleX(-1)'
                    }}
                    ref={myVideoRef}
                  />
                </div>
              )}
              <div
                className={
                  callDetails === 'Audio' ? 'AudioRemoteScreen' : 'RemoteScreen'
                }
                style={{ height: '100%' }}
              >
                {callDetails === 'Audio' && (
                  <>
                    <div
                      className={`profile-container ${
                        remoteStream ? 'speaking' : ''
                      }`}
                      style={{
                        display: 'inline-block',
                        borderRadius: '50%',
                        padding: '10px',
                        transition: 'box-shadow 0.3s ease',
                        boxShadow: remoteStream
                          ? '0 0 20px 5px rgba(0, 255, 0, 0.7)' // Glowing effect when speaking
                          : 'none'
                      }}
                    >
                      <img
                        src={remoteUserInfo?.pic}
                        alt={remoteUserInfo?.name}
                        className="profile-picture"
                        // className="profile-picture"
                        style={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '50%'
                        }}
                      />
                    </div>
                    <audio autoPlay ref={remoteVideoRef} />
                    {/* <AudioVisualizer audioStream={remoteStream} imageSrc={selectedChat?.users?.filter(user => user._id !== userInfo?._id)[0].pic} /> */}
                  </>
                )}
                {remoteStream && callDetails === 'Video' && (
                  <video
                    autoPlay
                    muted
                    playsInline
                    webkit-playsinline="true"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transform: 'scaleX(-1)'
                    }}
                    ref={remoteVideoRef}
                  />
                )}
              </div>
              <div className="call-buttons d-flex justify-content-evenly w-100 buttonContainer">
                {showCallModal == 'calling' ||
                CallCurrentStatus == 'Connecting' ||
                CallCurrentStatus == 'Connected' ||
                CallCurrentStatus == 'Rejected' ||
                CallCurrentStatus == 'Call End' ||
                CallCurrentStatus == 'Not Answered' ? (
                  <>
                    {/* <button
                      type="button"
                      class="btn btn-icon btn-lg btn-secondary  me-1 mb-1 rounded"
                    >
                      <Video size={24} />
                    </button> */}
                    {/* <button
                      type="button"
                      class="btn btn-icon btn-lg btn-secondary  me-1 mb-1 rounded"
                    >
                      <Volume2 size={20} />
                    </button> */}
                    {CallCurrentStatus === 'Connected' && (
                      <button
                        type="button"
                        className={`btn btn-icon btn-lg me-1 mb-1 rounded ${
                          isMicMuted ? 'btn-danger' : 'btn-secondary'
                        }`}
                        onClick={toggleMicMute}
                      >
                        {isMicMuted ? <MicOff size={20} /> : <Mic size={20} />}
                      </button>
                    )}
                    <button
                      class="btn btn-icon btn-lg btn-danger me-1 mb-1 rounded"
                      onClick={handleEndCall}
                    >
                      <PhoneOff size={20} />
                    </button>
                  </>
                ) : (
                  <>
                    {CallCurrentStatus === 'Incomming' && (
                      <>
                        {/* <button
                          type="button"
                          class="btn btn-icon btn-lg btn-secondary me-1 mb-1 rounded"
                        >
                          <MessageSquareText size={20} />
                        </button> */}
                        <button
                          class="btn btn-icon btn-lg btn-success me-1 mb-1 rounded"
                          onClick={handleIncommingCall}
                        >
                          <PhoneCall size={20} />
                        </button>
                      </>
                    )}
                    {(CallCurrentStatus === 'Incomming' ||
                      CallCurrentStatus == 'Rejected' ||
                      CallCurrentStatus == 'Not Answered' ||
                      CallCurrentStatus == 'Call End') && (
                      <button
                        class="btn btn-icon btn-lg btn-danger me-1 mb-1 rounded"
                        onClick={handleEndCall}
                      >
                        <PhoneOff size={20} />
                      </button>
                    )}
                  </>
                )}
                {/* {myStream && (
                    <button
                      class="btn btn-icon btn-lg btn-secondary  me-1 mb-1 rounded"
                      onClick={sendStreams}
                    >
                      <Video size={24} />
                      Send Stream
                    </button>
                  )}
                  {remoteSocketId && (
                    <button
                      class="btn btn-icon btn-lg btn-success me-1 mb-1 rounded"
                      onClick={handleCallUser}
                    >
                      <PhoneCall size={20} />
                    </button>
                  )}
                  {myStream && (
                    <button
                      class="btn btn-icon btn-lg btn-danger me-1 mb-1 rounded"
                      onClick={handleEndCall}
                    >
                      <PhoneOff size={20} /> End Call
                    </button>
                  )}
                  {!remoteSocketId && (
                    <button
                      class="btn btn-icon btn-lg btn-danger me-1 mb-1 rounded"
                      onClick={() => CancelCalling()}
                    >
                      <X size={20} />
                    </button>
                  )} */}
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}
const mapStateToProps = ({ auth, data }) => {
  const { authToken, userInfo } = auth
  const {
    selectedChat,
    socketConnected,
    showCallModal,
    chatList,
    callDetails,
    callData
  } = data
  return {
    authToken,
    userInfo,
    selectedChat,
    socketConnected,
    showCallModal,
    chatList,
    callDetails,
    callData
  }
}

const mapDispatchToProps = {
  setShowCallModal,
  setCallDetails,
  setCallData
}

export default connect(mapStateToProps, mapDispatchToProps)(Call)
